/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Starred_OnlyInputs */

const en_explorer_search_starred_only = /** @type {(inputs: Explorer_Search_Starred_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred only`)
};

const fr_explorer_search_starred_only = /** @type {(inputs: Explorer_Search_Starred_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred only`)
};

const de_explorer_search_starred_only = /** @type {(inputs: Explorer_Search_Starred_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred only`)
};

const it_explorer_search_starred_only = /** @type {(inputs: Explorer_Search_Starred_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred only`)
};

const ru_explorer_search_starred_only = /** @type {(inputs: Explorer_Search_Starred_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred only`)
};

const es_explorer_search_starred_only = /** @type {(inputs: Explorer_Search_Starred_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred only`)
};

const zh_cn2_explorer_search_starred_only = /** @type {(inputs: Explorer_Search_Starred_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred only`)
};

const ja_explorer_search_starred_only = /** @type {(inputs: Explorer_Search_Starred_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred only`)
};

const hi_explorer_search_starred_only = /** @type {(inputs: Explorer_Search_Starred_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred only`)
};

const pt_pt2_explorer_search_starred_only = /** @type {(inputs: Explorer_Search_Starred_OnlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starred only`)
};

/**
* | output |
* | --- |
* | "Starred only" |
*
* @param {Explorer_Search_Starred_OnlyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_starred_only = /** @type {((inputs?: Explorer_Search_Starred_OnlyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Starred_OnlyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_starred_only(inputs)
	if (locale === "de") return de_explorer_search_starred_only(inputs)
	if (locale === "it") return it_explorer_search_starred_only(inputs)
	if (locale === "ru") return ru_explorer_search_starred_only(inputs)
	if (locale === "es") return es_explorer_search_starred_only(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_starred_only(inputs)
	if (locale === "ja") return ja_explorer_search_starred_only(inputs)
	if (locale === "hi") return hi_explorer_search_starred_only(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_starred_only(inputs)
	return en_explorer_search_starred_only(inputs)
});